// Firebase App (the core Firebase SDK) is always required and must be listed first
export const firebase = require("firebase/app");

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import 'firebase/analytics';

// Add the Firebase products that you want to use
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBDH_9YovzWIRhlgR1BVbFq2DbHzBk5Dxg',
  authDomain: 'tonytalks.firebaseapp.com',
  databaseURL: 'https://tonytalks.firebaseio.com',
  projectId: 'tonytalks',
  storageBucket: 'tonytalks.appspot.com',
  messagingSenderId: '348844930530',
  appId: '1:348844930530:web:71e7814bb6c1a0e78475bb',
  measurementId: 'G-PD1XS677ZE'
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

export let storage = firebase.storage().ref();
export let db = firebase.firestore();
